import { IconsProps } from './IconsProps';

export const Tools = ({
  className = '',
  width = 24,
  height = 24,
  viewBox = '0 0 24 24',
  onClick,
  svgFill = 'currentColor',
  ariaLabel,
  ariaHidden,
}: IconsProps) => {
  return (
    <svg
      className={className}
      viewBox={viewBox}
      width={`${width}px`}
      height={`${height}px`}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      onClick={onClick}
      fill={svgFill}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <g id="tools">
        <path
          id="Vector"
          d="M20.7383 19.4603L19.4604 20.7383C19.2918 20.9059 19.0637 21 18.826 21C18.5882 21 18.3601 20.9059 18.1915 20.7383L7.50036 10.0647C7.20771 10.1495 6.90507 10.1949 6.60043 10.1997C6.02745 10.1993 5.46284 10.0621 4.95355 9.79956C4.44426 9.537 4.005 9.15665 3.6723 8.69014C3.33959 8.22363 3.12305 7.68443 3.04068 7.11738C2.9583 6.55033 3.01248 5.9718 3.1987 5.4299L5.48452 7.71581L5.96148 7.23883L7.23938 5.96088L7.71634 5.4839L5.43052 3.19799C5.9724 3.01177 6.5509 2.95759 7.11793 3.03996C7.68496 3.12234 8.22413 3.33889 8.69063 3.67161C9.15712 4.00433 9.53745 4.4436 9.8 4.95291C10.0626 5.46222 10.1997 6.02685 10.2001 6.59986C10.1953 6.90451 10.1499 7.20716 10.0652 7.49982L20.7383 18.1914C20.9059 18.36 21 18.5881 21 18.8259C21 19.0636 20.9059 19.2917 20.7383 19.4603ZM3.26169 18.1914C3.09408 18.36 3 18.5881 3 18.8259C3 19.0636 3.09408 19.2917 3.26169 19.4603L4.53959 20.7383C4.7082 20.9059 4.93629 21 5.17404 21C5.41179 21 5.63988 20.9059 5.80849 20.7383L10.7311 15.8245L8.1843 13.2776M19.1994 3L15.5997 4.79993V6.59986L13.6469 8.55278L15.4467 10.3527L17.3996 8.39979H19.1994L20.9993 4.79993L19.1994 3Z"
          fill={svgFill}
        />
      </g>
    </svg>
  );
};

export default Tools;
